import type { RouteRecordRaw } from 'vue-router';
import { manageRoute, promotionAddProductRoute, promotionDetailRoute, promotionEditRoute, promotionRoute, couponRoute, couponAddRoute, couponEditRoute, shipmentRoute, shipmentDetailRoute, shipmentListRoute, wholesaleAddRoute, wholesaleEditRoute, wholesaleDetailRoute, wholesaleRoute, commissionCategoryRoute, addCommissionCategoryRoute, editCommissionCategoryRoute } from '@/pages/manage/route';
import { customerAddressRoute, customerDetailRoute, customerRoute } from '@/pages/manage/route/customer';
import { categoryRoute } from '@/pages/manage/route/category';
import { AddCategoryRoute } from '@/pages/product/route/category';
import { addKolRoute, kolDetailRoute, kolRoute, kolRequestRoute } from '@/pages/kol/route';

export const manageRoutes: RouteRecordRaw = {
  path: '/manage',
  component: () => import('@/layouts/main.vue'),
  children: [
    manageRoute,
    customerRoute(),
    customerDetailRoute(),
    customerAddressRoute(),
    categoryRoute(),
    AddCategoryRoute(),
    kolRoute(),
    addKolRoute(),
    kolRequestRoute(),
    kolDetailRoute(),
    promotionRoute(),
    promotionDetailRoute(),
    promotionAddProductRoute(),
    promotionEditRoute(),
    couponRoute(),
    couponAddRoute(),
    couponEditRoute(),
    shipmentRoute(),
    shipmentDetailRoute(),
    shipmentListRoute(),
    wholesaleRoute(),
    wholesaleDetailRoute(),
    wholesaleEditRoute(),
    wholesaleAddRoute(),
    commissionCategoryRoute(),
    addCommissionCategoryRoute(),
    editCommissionCategoryRoute(),
  ]
};
